import { render, staticRenderFns } from "./modalPazSalvo.vue?vue&type=template&id=5646d358&scoped=true"
import script from "./modalPazSalvo.vue?vue&type=script&lang=js"
export * from "./modalPazSalvo.vue?vue&type=script&lang=js"
import style0 from "./modalPazSalvo.vue?vue&type=style&index=0&id=5646d358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646d358",
  null
  
)

export default component.exports